import {
  IGetUserDataByRequestResponse,
  IGetUserDataByRequestResponseError,
} from '../repositories/monolith-python/v1/get-user-data-by-request';
import { IUsersResponse, IUsersResponseError } from '../types/user/user';
import { IFastFiltersUserSchema } from '../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';

export function mapUserResponse(response: IGetUserDataByRequestResponse): IUsersResponse {
  return {
    statusCode: 200,
    headers: [],
    response: {
      user: response.data.user as IFastFiltersUserSchema,
    },
  };
}

export function mapUserResponseError(response: IGetUserDataByRequestResponseError): IUsersResponseError {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
}
